export * from './FechamentoDeCaixaServiceAdapter'
